import { MapLabelText } from '../__types';

function calcWidth(text: string, fontSize: number): number {
  const longest = text
    .split('\n')
    .reduce((prev, curr) => (prev.length > curr.length ? prev : curr));
  const len =
    longest.length +
    longest.split('').filter(l => 'muw'.includes(l.toLowerCase())).length;
  return len * fontSize * 0.88;
}

function batchCalcWidth(textArray: MapLabelText[]) {
  return textArray.map(text => {
    text['width'] = calcWidth(text.text, text.textType.fontSize);
  });
}

export default batchCalcWidth;
